// extracted by mini-css-extract-plugin
module.exports = {"star1":"rainbowIconStyle_star1__2YkJ_","star2":"rainbowIconStyle_star2__PL_O5","star3":"rainbowIconStyle_star3__1wCM5","rainbow":"rainbowIconStyle_rainbow__1ZEsd"};